import config from '../config.ts';

export const getYentaImageUrl = (
  path: string | undefined,
): string | undefined =>
  path ? `${config.imageBaseUrl.yentaImageBaseUrl}/${path}` : undefined;

export const getLeoMediaUrl = (path: string | undefined): string | undefined =>
  path ? `${config.leoMediaBaseUrl}${path}` : undefined;
